export default [
  {
    path: '/act-one-detail',
    name: 'actOneDetail',
    component: () => import('@/view/activities/wed-activities/act-one-detail.vue')
  },
  {
    path: '/act-one-rules',
    name: 'actOneRules',
    component: () => import('@/view/activities/wed-activities/act-one-rules.vue')
  },
  {
    path: '/act-two-detail',
    name: 'actTwoDetail',
    component: () => import('@/view/activities/wed-activities/act-two-detail.vue')
  },
  {
    path: '/act-two-rules',
    name: 'actTwoRules',
    component: () => import('@/view/activities/wed-activities/act-two-rules.vue')
  },
  {
    path: '/act-four-detail', // 抽签活动
    name: 'actfourDetail',
    component: () => import('@/view/activities/wed-activities/act-four-detail')
  },
  {
    path: '/act-four-rules',
    name: 'actFourRules',
    component: () => import('@/view/activities/wed-activities/act-four-detail/rules.vue')
  },
  {
    path: '/act-three-detail', // 集宝石活动
    name: 'actThreeDetail',
    component: () => import('@/view/activities/wed-activities/act-three-detail')
  },
  {
    path: '/act-three-rules',
    name: 'actThreeRules',
    component: () => import('@/view/activities/wed-activities/act-three-detail/rules.vue')
  },
  {
    path: '/actvie/share',
    name: 'actvieShare',
    component: () => import('@/view/activities/share/index.vue')
  },
  {
    path: '/actvie/share/rule',
    name: 'actvieShareRule',
    component: () => import('@/view/activities/share/rule.vue')
  },
  {
    path: '/actvie/share/list',
    name: 'actvieShareList',
    component: () => import('@/view/activities/share/shared-list.vue')
  },
  {
    path: '/actvie/vip-day',
    name: 'actVipDay',
    component: () => import('@/view/activities/vipDay/index.vue')
  },
  {
    path: '/actvie/oldCustomerBonus',
    name: 'oldCustomerBonus',
    component: () => import('@/view/activities/oldCustomerBonus/index.vue')
  }, {
    path: '/actvie/oldCustomerBonus/rule',
    name: 'oldCustomerBonusRule',
    component: () => import('@/view/activities/oldCustomerBonus/rule.vue')
  }
]
